// 3rd party libs
import {
    mapActions,
    mapGetters,
} from 'vuex';
import {
    bcmul,
} from 'locutus/php/bc';

// Shared
import sharedEpicTypes from '@shared/epics/types.js';

// Helper
import {
    truncateValueToDecimalPlaces,
} from '@shared/utils/formatter.js';

export default {
    computed: {
        ...mapGetters('remoteConfig', ['remoteConfigByKey']),

        defaultFiatValue() {
            return this.remoteConfigByKey('defaultFiatValue') || 0;
        },
    },

    methods: {
        ...mapActions({
            getCurrencyConversionRates: sharedEpicTypes.GET_CURRENCY_CONVERSION_RATES,
        }),

        ...mapActions('wallet', ['setSendOutBalance']),

        /**
         * Switch currency coversion rates crypto <> fiat
         *
         * @returns {void}
         */
        walletMixinSwitchCurrencyConversionRate() {
            this.currentRate = this.currentRate === this.cryptoToFiat.rate ? this.fiatToCrypto.rate : this.cryptoToFiat.rate;
            this.currentRateDate = this.currentRateDate === this.cryptoToFiat.date ? this.fiatToCrypto.date : this.cryptoToFiat.date;
        },

        /**
         * Refresh currency coveration rates according the from and to list
         *
         * @param {string[]} currenciesFromList The ids to covert from
         * @param {string[]} currenciesToList The ids to covert into
         * @returns {void}
         */
        async walletMixinRefreshCurrencyConversionRates(currenciesFromList, currenciesToList) {
            // Get both conversion rate during the first time and set crypto to fiat as the initial
            this.isLoading = true;

            await this.getCurrencyConversionRates({
                currenciesFromList,
                currenciesToList,
            });
        },

        /**
         * Sets fiat original and formatted values, should also switch currencies
         *
         * @returns {void}
         */
        walletMixinSetFiatValue() {
            this.walletMixinSwitchCurrencies();
            this.walletMixinSwitchCurrencyConversionRate();

            // Currencies are switched so fiat is crypto now
            this.fiatValue.original = this.chzAmountToBuy;
            this.fiatValue.formatted = truncateValueToDecimalPlaces(this.fiatValue.original);
            this.cryptoValue.original = bcmul(this.fiatValue.original, this.currentRate, this.cryptoCurrency.decimalDetail);
            this.cryptoValue.formatted = truncateValueToDecimalPlaces(this.cryptoValue.original);
        },

        /**
         * Sets crypto original and formatted values
         *
         * @returns {void}
         */
        walletMixinSetCryptoValue() {
            if (this.fiatValue.original) {
                this.cryptoValue.original = bcmul(this.fiatValue.original, this.currentRate, this.cryptoCurrency.decimalDetail);
                this.cryptoValue.formatted = truncateValueToDecimalPlaces(this.cryptoValue.original);
            }

            // Show 0 in the label as a "placeholder" value
            if (!Number(this.cryptoValue.formatted)) {
                this.cryptoValue.formatted = 0;
            }
        },

        /**
         * Reset the values
         *
         * @param {boolean} updateSendOutBalance - flag whether to update the send out balance in the store. Defaults to true
         * @returns {void}
         */
        walletMixinResetFiatAndCryptoValues(updateSendOutBalance = true) {
            this.isLoading = true;

            this.cryptoValue.original = '0';
            this.fiatValue.original = '0';

            this.fiatToCrypto = {
                rate: null,
                date: null,
            };
            this.cryptoToFiat = {
                rate: null,
                date: null,
            };

            if (updateSendOutBalance) {
                this.setSendOutBalance();
            }
        },

        /**
         * Switch currencies crypto <> fiat
         *
         * @returns {void}
         */
        walletMixinSwitchCurrencies() {
            this.isCryptoMainCurrency = !this.isCryptoMainCurrency;

            // Switching labels
            this.switched = !this.switched;
            this.isCurrencySwitched = true;

            // Prevent assigning reactive objects to each other
            const oldFiatCurrency = Object.assign({}, this.fiatCurrency);
            const oldFiatValue = Object.assign({}, this.fiatValue);
            const oldCryptoCurrency = Object.assign({}, this.cryptoCurrency);
            const oldCryptoValue = Object.assign({}, this.cryptoValue);

            this.fiatCurrency = oldCryptoCurrency;
            this.cryptoCurrency = oldFiatCurrency;

            // Switching fields
            this.fiatValue = oldCryptoValue;
            this.cryptoValue = oldFiatValue;
        },
    },
};